// extracted by mini-css-extract-plugin
module.exports = {"achievementBadge":"AchievementBadge_achievementBadge__7GyKv","achievementBadgeButton":"AchievementBadge_achievementBadgeButton__S_AMP"};